import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { BifIconEye, Button, OverlayTrigger, Tooltip } from "banafo-design-system";
const PreviewImageButton = ({ handlePreviewImage }) => {
    const { t } = useTranslation();
    return (_jsx(OverlayTrigger, { placement: 'top', overlay: _jsx(Tooltip, { id: "open-note", children: t('View_') }), children: _jsx(Button, { variant: "link", size: 'sm', className: "text-dark", onClick: handlePreviewImage, children: _jsx(BifIconEye, {}) }) }));
};
export default PreviewImageButton;
